import { createContext } from "react";

export const PolicyContext = createContext({});
